<!-- <nav class="navbar navbar-expand navbar-fixed-top bg-blue">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img src="/logo.png" style="width: 70px" />
    </a>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link" href="/demo">Demo <span class="sr-only">(current)</span></a>
          <p-autoComplete [(ngModel)]="selectedWord" [showEmptyMessage]="true" [suggestions]="results" field="label" (onSelect)="onSelectSearch()"
            (completeMethod)="filterBooks($event)" [minLength]="1">
            <ng-template let-brand pTemplate="item">
              <div *ngIf="brand?.key === 'key1'" class="result-item">
                <img [src]="brand?.keyword1?.urlKeyword1" />
                <div class="fil-name">
                  <span>{{brand.keyword1.keyword_en}}</span>
                  <p>{{brand.keyword1.keyword_vn}}</p>
                </div>

              </div>
              <div *ngIf="brand?.key === 'key2'" class="result-item">
                <img [src]="brand?.keyword2?.urlKeyword2" />
                <div class="fil-name">
                  <span>{{brand.keyword2.keyword_en}}</span>
                  <p>{{brand.keyword2.keyword_vn}}</p>
                </div>

              </div>
            </ng-template>

          </p-autoComplete>
        </li>
      </ul>
    </div>
    <button class="btn btn-outline-success my-2 my-sm-0" (click)="logout()" *ngIf="currentUser">Logout</button>
  </div>
</nav>
<div class="jumbotron">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div> -->

<div class="app-body">
	<!-- <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized" (minimizedChange)="toggleMinimize($event)">
      <div class="info-member">
          <app-header
          [navbarBrandRouterLink]="['/khach-hang/danh-sach-khach-hang']"
          [navbarBrandFull]="{src: 'assets/img/logo.svg', width: 148, alt: 'CoreUI Logo'}"
          [navbarBrandMinimized]="{src: 'assets/img/brand/sygnet.svg', width: 30, height: 30, alt: 'CoreUI Logo'}"
          [sidebarToggler]="'lg'"
          [asideMenuToggler]="false">
        </app-header>
          <img class="icon-logo" src="assets/img/logo.png">
          <div class="avatar">
            <a  [routerLink]="['/profile']">
              <div class="avartar-profile" style="width: 64px; height: 64px;">
                <img src="../../../assets/img/img-avata.png" class="img-avatar" alt="Ảnh avatar" />
              </div>
            </a>
          </div>
          <div class="info">
              <h4>LE NGOC ANH</h4>
              <p>ngocanh@sunshinegroup.vn</p>
          </div>
          <div class="act">
            <div class="note">
              <a title="note" style="cursor: pointer;">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9084 5.25114H3.76761V17.9017H13.9084V5.25114ZM3.76761 3.98608C3.06753 3.98608 2.5 4.55247 2.5 5.25114V17.9017C2.5 18.6004 3.06753 19.1668 3.76761 19.1668H13.9084C14.6085 19.1668 15.1761 18.6004 15.1761 17.9017V5.25114C15.1761 4.55247 14.6085 3.98608 13.9084 3.98608H3.76761Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.82715 8.20284C5.82715 7.85351 6.11091 7.57031 6.46095 7.57031H11.2145C11.5645 7.57031 11.8483 7.85351 11.8483 8.20284C11.8483 8.55218 11.5645 8.83537 11.2145 8.83537H6.46095C6.11091 8.83537 5.82715 8.55218 5.82715 8.20284Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.82715 11.5764C5.82715 11.227 6.11091 10.9438 6.46095 10.9438H11.2145C11.5645 10.9438 11.8483 11.227 11.8483 11.5764C11.8483 11.9257 11.5645 12.2089 11.2145 12.2089H6.46095C6.11091 12.2089 5.82715 11.9257 5.82715 11.5764Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.82715 14.9499C5.82715 14.6006 6.11091 14.3174 6.46095 14.3174H11.2145C11.5645 14.3174 11.8483 14.6006 11.8483 14.9499C11.8483 15.2992 11.5645 15.5824 11.2145 15.5824H6.46095C6.11091 15.5824 5.82715 15.2992 5.82715 14.9499Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.24609 2.29928C5.24609 1.94994 5.52986 1.66675 5.8799 1.66675H16.232C16.9321 1.66675 17.4996 2.23313 17.4996 2.93181V14.9499C17.4996 15.2992 17.2159 15.5824 16.8658 15.5824C16.5158 15.5824 16.232 15.2992 16.232 14.9499L16.232 2.93181H5.8799C5.52986 2.93181 5.24609 2.64861 5.24609 2.29928Z" fill="white"/>
                 </svg>
              </a>
            </div>
            <div class="date">
              <a title="date" style="cursor: pointer;">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6906 3.16177C13.6906 2.79629 13.4028 2.5 13.0477 2.5C12.6927 2.5 12.4049 2.79629 12.4049 3.16177V3.47026H7.59515V3.16177C7.59515 2.79629 7.30733 2.5 6.95229 2.5C6.59725 2.5 6.30943 2.79629 6.30943 3.16177V3.47026H4.66667C3.53543 3.47026 2.5 4.33477 2.5 5.54383V15.4264C2.5 16.6355 3.53543 17.5 4.66667 17.5H15.3333C16.4646 17.5 17.5 16.6355 17.5 15.4264V5.54383C17.5 4.33477 16.4646 3.47026 15.3333 3.47026H13.6906V3.16177ZM16.2143 7.7063V5.54383C16.2143 5.19346 15.8852 4.7938 15.3333 4.7938H13.6906V5.36769C13.6906 5.73317 13.4028 6.02946 13.0477 6.02946C12.6927 6.02946 12.4049 5.73317 12.4049 5.36769V4.7938H7.59515V5.36769C7.59515 5.73317 7.30733 6.02946 6.95229 6.02946C6.59725 6.02946 6.30943 5.73317 6.30943 5.36769V4.7938H4.66667C4.11475 4.7938 3.78571 5.19346 3.78571 5.54383V7.7063H16.2143ZM3.78571 9.02985H16.2143V15.4264C16.2143 15.7768 15.8852 16.1765 15.3333 16.1765H4.66667C4.11475 16.1765 3.78571 15.7768 3.78571 15.4264V9.02985Z" fill="white"/>
                  <path d="M5.71429 10.6619H7.42857V12.4266H5.71429V10.6619Z" fill="white"/>
                  <path d="M9.14286 10.6619H10.8571V12.4266H9.14286V10.6619Z" fill="white"/>
                  <path d="M12.5714 10.6619H14.2857V12.4266H12.5714V10.6619Z" fill="white"/>
                </svg>
              </a>
            </div>
            <div class="logout">
                <a title="logout" (click)="logout()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.71067 2.5C4.12436 2.5 3.56207 2.73291 3.14749 3.14749C2.73291 3.56207 2.5 4.12436 2.5 4.71067V15.2888C2.5 15.8751 2.73291 16.4374 3.14749 16.852C3.56207 17.2666 4.12436 17.4995 4.71067 17.4995H7.73299C8.11932 17.4995 8.4325 17.1863 8.4325 16.8C8.4325 16.4137 8.11932 16.1005 7.73299 16.1005H4.71067C4.4954 16.1005 4.28895 16.015 4.13674 15.8627C3.98452 15.7105 3.89901 15.5041 3.89901 15.2888V4.71067C3.89901 4.4954 3.98452 4.28895 4.13674 4.13674C4.28895 3.98452 4.4954 3.89901 4.71067 3.89901H7.73299C8.11932 3.89901 8.4325 3.58583 8.4325 3.1995C8.4325 2.81318 8.11932 2.5 7.73299 2.5H4.71067Z" fill="white"/>
                    <path d="M13.5171 5.72748C13.244 5.4543 12.8011 5.4543 12.5279 5.72748C12.2547 6.00065 12.2547 6.44355 12.5279 6.71672L15.1117 9.30051H7.73289C7.34657 9.30051 7.03339 9.61369 7.03339 10C7.03339 10.3863 7.34657 10.6995 7.73289 10.6995H15.1117L12.5279 13.2833C12.2547 13.5565 12.2547 13.9994 12.5279 14.2725C12.8011 14.5457 13.244 14.5457 13.5171 14.2725L17.2951 10.4946C17.5682 10.2215 17.5682 9.77856 17.2951 9.50538L13.5171 5.72748Z" fill="white"/>
                  </svg>
                </a>
            </div>
          </div>
      </div>
      <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="appSidebar.minimized"></app-sidebar-nav>
    </app-sidebar> -->
	<p-sidebar [(visible)]="display" position="left" [baseZIndex]="10000">
		<div class="info-member">
			<div style="width: 100%;padding: 10px;text-align: right;">
				<img src="assets/img/logo.png">
			</div>
			<div class="bl-logined avatar">
				<a [routerLink]="['/profile']">
					<div class="avartar-profile">
						<img src="../../../assets/img/img-avata.png" class="img-avatar" alt="Ảnh avatar" />
					</div>
				</a>
			</div>
			<div class="bl-logined info">
				<h4>{{currentUser?.fullName}}</h4>
				<p>{{currentUser?.email}}</p>
			</div>
			<div class="bl-logined act">
				<div class="note bl-developing">
					<a title="note" style="cursor: pointer;">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M13.9084 5.25114H3.76761V17.9017H13.9084V5.25114ZM3.76761 3.98608C3.06753 3.98608 2.5 4.55247 2.5 5.25114V17.9017C2.5 18.6004 3.06753 19.1668 3.76761 19.1668H13.9084C14.6085 19.1668 15.1761 18.6004 15.1761 17.9017V5.25114C15.1761 4.55247 14.6085 3.98608 13.9084 3.98608H3.76761Z"
								fill="white" />
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M5.82715 8.20284C5.82715 7.85351 6.11091 7.57031 6.46095 7.57031H11.2145C11.5645 7.57031 11.8483 7.85351 11.8483 8.20284C11.8483 8.55218 11.5645 8.83537 11.2145 8.83537H6.46095C6.11091 8.83537 5.82715 8.55218 5.82715 8.20284Z"
								fill="white" />
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M5.82715 11.5764C5.82715 11.227 6.11091 10.9438 6.46095 10.9438H11.2145C11.5645 10.9438 11.8483 11.227 11.8483 11.5764C11.8483 11.9257 11.5645 12.2089 11.2145 12.2089H6.46095C6.11091 12.2089 5.82715 11.9257 5.82715 11.5764Z"
								fill="white" />
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M5.82715 14.9499C5.82715 14.6006 6.11091 14.3174 6.46095 14.3174H11.2145C11.5645 14.3174 11.8483 14.6006 11.8483 14.9499C11.8483 15.2992 11.5645 15.5824 11.2145 15.5824H6.46095C6.11091 15.5824 5.82715 15.2992 5.82715 14.9499Z"
								fill="white" />
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M5.24609 2.29928C5.24609 1.94994 5.52986 1.66675 5.8799 1.66675H16.232C16.9321 1.66675 17.4996 2.23313 17.4996 2.93181V14.9499C17.4996 15.2992 17.2159 15.5824 16.8658 15.5824C16.5158 15.5824 16.232 15.2992 16.232 14.9499L16.232 2.93181H5.8799C5.52986 2.93181 5.24609 2.64861 5.24609 2.29928Z"
								fill="white" />
						</svg>
					</a>
				</div>
				<div class="date bl-developing">
					<a title="date" style="cursor: pointer;">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M13.6906 3.16177C13.6906 2.79629 13.4028 2.5 13.0477 2.5C12.6927 2.5 12.4049 2.79629 12.4049 3.16177V3.47026H7.59515V3.16177C7.59515 2.79629 7.30733 2.5 6.95229 2.5C6.59725 2.5 6.30943 2.79629 6.30943 3.16177V3.47026H4.66667C3.53543 3.47026 2.5 4.33477 2.5 5.54383V15.4264C2.5 16.6355 3.53543 17.5 4.66667 17.5H15.3333C16.4646 17.5 17.5 16.6355 17.5 15.4264V5.54383C17.5 4.33477 16.4646 3.47026 15.3333 3.47026H13.6906V3.16177ZM16.2143 7.7063V5.54383C16.2143 5.19346 15.8852 4.7938 15.3333 4.7938H13.6906V5.36769C13.6906 5.73317 13.4028 6.02946 13.0477 6.02946C12.6927 6.02946 12.4049 5.73317 12.4049 5.36769V4.7938H7.59515V5.36769C7.59515 5.73317 7.30733 6.02946 6.95229 6.02946C6.59725 6.02946 6.30943 5.73317 6.30943 5.36769V4.7938H4.66667C4.11475 4.7938 3.78571 5.19346 3.78571 5.54383V7.7063H16.2143ZM3.78571 9.02985H16.2143V15.4264C16.2143 15.7768 15.8852 16.1765 15.3333 16.1765H4.66667C4.11475 16.1765 3.78571 15.7768 3.78571 15.4264V9.02985Z"
								fill="white" />
							<path d="M5.71429 10.6619H7.42857V12.4266H5.71429V10.6619Z" fill="white" />
							<path d="M9.14286 10.6619H10.8571V12.4266H9.14286V10.6619Z" fill="white" />
							<path d="M12.5714 10.6619H14.2857V12.4266H12.5714V10.6619Z" fill="white" />
						</svg>
					</a>
				</div>
				<div class="logout">
					<a title="logout" (click)="logout()">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path
								d="M4.71067 2.5C4.12436 2.5 3.56207 2.73291 3.14749 3.14749C2.73291 3.56207 2.5 4.12436 2.5 4.71067V15.2888C2.5 15.8751 2.73291 16.4374 3.14749 16.852C3.56207 17.2666 4.12436 17.4995 4.71067 17.4995H7.73299C8.11932 17.4995 8.4325 17.1863 8.4325 16.8C8.4325 16.4137 8.11932 16.1005 7.73299 16.1005H4.71067C4.4954 16.1005 4.28895 16.015 4.13674 15.8627C3.98452 15.7105 3.89901 15.5041 3.89901 15.2888V4.71067C3.89901 4.4954 3.98452 4.28895 4.13674 4.13674C4.28895 3.98452 4.4954 3.89901 4.71067 3.89901H7.73299C8.11932 3.89901 8.4325 3.58583 8.4325 3.1995C8.4325 2.81318 8.11932 2.5 7.73299 2.5H4.71067Z"
								fill="white" />
							<path
								d="M13.5171 5.72748C13.244 5.4543 12.8011 5.4543 12.5279 5.72748C12.2547 6.00065 12.2547 6.44355 12.5279 6.71672L15.1117 9.30051H7.73289C7.34657 9.30051 7.03339 9.61369 7.03339 10C7.03339 10.3863 7.34657 10.6995 7.73289 10.6995H15.1117L12.5279 13.2833C12.2547 13.5565 12.2547 13.9994 12.5279 14.2725C12.8011 14.5457 13.244 14.5457 13.5171 14.2725L17.2951 10.4946C17.5682 10.2215 17.5682 9.77856 17.2951 9.50538L13.5171 5.72748Z"
								fill="white" />
						</svg>
					</a>
				</div>
			</div>
			<div class="bl-logined sidebar-nav" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
				<div class="nav-item">
					<a class="nav-link" routerLink="/main" [routerLinkActive]="['is-active']">
						<i class="pi pi-home"></i>
						Trang chủ</a>
				</div>
				<!-- <div class="nav-item">
					<a class="nav-link" routerLink="/demo" [routerLinkActive]="['is-active']"> <i
							class="pi pi-id-card"></i>Demo</a>
				</div> -->
				<div class="nav-item">
					<a class="nav-link" routerLink="/quiz" [routerLinkActive]="['is-active']"><i
							class="pi pi-check-square"></i>
						Bài kiểm tra</a>
				</div>
			</div>
		</div>
	</p-sidebar>
	<!-- Main content -->
	<main class="main">
		<div class="app-header-main">
			<div class="search-header">
				<div class="menu-bar" (click)="toggleSideBar()">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M21 10H7" stroke="#333333" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round" />
						<path d="M21 6H3" stroke="#333333" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round" />
						<path d="M21 14H3" stroke="#333333" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round" />
						<path d="M21 18H7" stroke="#333333" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round" />
					</svg>
				</div>
				<div class="pl-3 pt-1 pr-3" onclick="location.href='/'+location.href.split('/')[3]">
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house-door" viewBox="0 0 16 16">
					  <path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z"/>
					</svg>
				</div>
				<button type="submit" class="btn bl-logined">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path fill-rule="evenodd" clip-rule="evenodd"
							d="M15.1958 16.8928C13.9284 17.8156 12.3678 18.36 10.68 18.36C6.43846 18.36 3 14.9216 3 10.68C3 6.43846 6.43846 3 10.68 3C14.9216 3 18.36 6.43846 18.36 10.68C18.36 12.3678 17.8156 13.9284 16.8928 15.1958L20.6485 18.9515C21.1172 19.4201 21.1172 20.1799 20.6485 20.6485C20.1799 21.1172 19.4201 21.1172 18.9515 20.6485L15.1958 16.8928ZM16.92 10.68C16.92 14.1263 14.1263 16.92 10.68 16.92C7.23376 16.92 4.44 14.1263 4.44 10.68C4.44 7.23376 7.23376 4.44 10.68 4.44C14.1263 4.44 16.92 7.23376 16.92 10.68Z"
							fill="#333333" />
					</svg>
				</button>
				<p-autoComplete class="bl-logined" [(ngModel)]="selectedWord" [showEmptyMessage]="true" [suggestions]="results"
					field="label" (onSelect)="onSelectSearch()" (completeMethod)="filterBooks($event)" [minLength]="1">
					<ng-template let-brand pTemplate="item">
						<div *ngIf="brand?.key === 'key1'" class="result-item">
							<img [src]="getCdnImage(brand?.keyword1?.urlKeyword1)" />
							<div class="fil-name">
								<span>{{brand.keyword1.keyword_en}}</span>
								<p>{{brand.keyword1.keyword_vn}}</p>
							</div>
						</div>
						<div *ngIf="brand?.key === 'key2'" class="result-item">
							<img [src]="brand?.keyword2?.urlKeyword2" />
							<div class="fil-name">
								<span>{{brand.keyword2.keyword_en}}</span>
								<p>{{brand.keyword2.keyword_vn}}</p>
							</div>

						</div>
					</ng-template>

				</p-autoComplete>
				<!-- <input type="text" class="form-control" placeholder="Tìm kiếm..." /> -->
			</div>
			<div class="right-header">
				<div class="full-screen ml-auto" (click)="toggleFullScreen()">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path
							d="M8 3V6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8H3M21 8H18C17.4696 8 16.9609 7.78929 16.5858 7.41421C16.2107 7.03914 16 6.53043 16 6V3M16 21V18C16 17.4696 16.2107 16.9609 16.5858 16.5858C16.9609 16.2107 17.4696 16 18 16H21M3 16H6C6.53043 16 7.03914 16.2107 7.41421 16.5858C7.78929 16.9609 8 17.4696 8 18V21"
							stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</div>
				<div class="notification bl-logined">
					<a class="pd-0" href="#">
						<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M0.0719345 12.3846L0.95703 9.57746L1.28714 5.58006C1.54759 2.42615 4.16452 0 7.30601 0H7.69399C10.8355 0 13.4524 2.42615 13.7129 5.58006L14.043 9.57746L14.9281 12.3846C15.2373 13.3655 14.5106 14.3662 13.489 14.3662L11.2747 14.3662C11.2747 14.8496 11.1746 15.3272 10.9813 15.7712C10.788 16.2151 10.506 16.6155 10.1537 16.9508C9.80135 17.286 9.38542 17.5498 8.93062 17.729C8.47588 17.9082 7.98985 18 7.49994 18C7.01003 18 6.524 17.9082 6.06926 17.729C5.61446 17.5498 5.19853 17.286 4.84622 16.9508C4.49383 16.6155 4.21184 16.2151 4.01859 15.7712C3.82529 15.3272 3.72515 14.8496 3.72515 14.3662H1.511C0.489383 14.3662 -0.237349 13.3655 0.0719345 12.3846ZM1.511 12.8451L2.44763 9.8745L2.79185 5.70617C2.98719 3.34074 4.9499 1.52113 7.30601 1.52113H7.69399C10.0501 1.52113 12.0128 3.34074 12.2081 5.70617L12.5524 9.8745L13.489 12.8451H1.511ZM5.23506 14.3662C5.23506 14.6374 5.29115 14.9071 5.40136 15.1603C5.51163 15.4136 5.67453 15.6466 5.88297 15.8449C6.0915 16.0434 6.34137 16.2029 6.61934 16.3124C6.89736 16.422 7.19671 16.4789 7.49994 16.4789C7.80317 16.4789 8.10251 16.422 8.38053 16.3124C8.65851 16.2029 8.90838 16.0434 9.11691 15.8449C9.32535 15.6466 9.48824 15.4136 9.59851 15.1603C9.70873 14.9071 9.76481 14.6374 9.76481 14.3662L5.23506 14.3662Z"
								fill="#333333" />
						</svg>
						<span class="badge badge-pill badge-danger">22</span>
					</a>
				</div>
				<ul class="nav navbar-nav bl-logined bl-user-panel">
					<li class="nav-item dropdown" dropdown placement="bottom right">
						<a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
							aria-expanded="false" dropdownToggle (click)="false"
							style="display: flex; align-items: center;">
							<div class="avartar-profile">
								<!-- <img src="../../../assets/img/img-avata.png" class="img-avatar" alt="Ảnh avatar" /> -->
								<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" style="margin-right: 7px;color: #ccc;" fill="currentColor" viewBox="0 0 16 16">
								  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
								  <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
								</svg>
							</div>
							{{currentUser?.fullName}}
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
								fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M7.20921 9.21967C6.93026 9.51256 6.93026 9.98744 7.20921 10.2803L11.4949 14.7803C11.7739 15.0732 12.2261 15.0732 12.5051 14.7803L16.7908 10.2803C17.0697 9.98744 17.0697 9.51256 16.7908 9.21967C16.5118 8.92678 16.0596 8.92678 15.7806 9.21967L12 13.1893L8.21936 9.21967C7.94042 8.92678 7.48816 8.92678 7.20921 9.21967Z"
									fill="#333333" />
							</svg>
						</a>
						<div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
							<div class="dropdown-header text-center"><strong>Account</strong></div>
							<a class="dropdown-item" href="#"><i class="fa fa-bell-o"></i> Updates<span
									class="badge badge-info">42</span></a>
							<a class="dropdown-item" href="#"><i class="fa fa-envelope-o"></i> Messages<span
									class="badge badge-success">42</span></a>
							<a class="dropdown-item" href="#"><i class="fa fa-tasks"></i> Tasks<span
									class="badge badge-danger">42</span></a>
							<a class="dropdown-item" href="#"><i class="fa fa-comments"></i> Comment<span
									class="badge badge-warning">42</span></a>
							<div class="dropdown-header text-center"><strong>Settings</strong></div>
							<a class="dropdown-item" [routerLink]="['/profile']"> <i class="fa fa-user"></i> Profile</a>
							<a class="dropdown-item" href="#"><i class="fa fa-wrench"></i> Setting</a>
							<a class="dropdown-item" href="#"><i class="fa fa-usd"></i> Payments<span
									class="badge badge-dark">42</span></a>
							<a class="dropdown-item" href="#"><i class="fa fa-file"></i> Projects<span
									class="badge badge-primary">42</span></a>
							<div class="divider"></div>
							<a class="dropdown-item" href="#"><i class="fa fa-shield"></i> Lock account</a>
							<a class="dropdown-item" (click)="logout()"><i class=" fa fa-lock"></i> Logout</a>
						</div>
					</li>
				</ul>

			</div>
		</div>
		<div class="app-body-main container-fluid p-2 p-md-3">
			<router-outlet></router-outlet>
		</div>
	</main>
</div>
